<template>
   <section class="about__area pt-90 pb-150">
      <div class="container">
         <div class="row">
            <div class="col-xxl-5 offset-xxl-1 col-xl-6 col-lg-6">
               <div class="about__thumb-wrapper">
                  <div class="about__thumb ml-100">
                     <img src="../../assets/img/about/about.jpg" alt="">
                  </div>
               </div>
            </div>
            <div class="col-xxl-6 col-xl-6 col-lg-6">
               <div class="about__content pl-70 pr-60 pt-25">
                  <div class="section__title-wrapper mb-25">
                     <h2 class="section__title">GelişimP <br><span class="yellow-bg-big">Türkiye <img src="../../assets/img/shape/yellow-bg-2.png" alt="">
                     </span> </h2>
                     <p>Psikoloji biliminin ışığında, her yaş insanın gelişimine katkı sağlamak amacıyla kurulmuş, özgün eğitimlerin verildiği bir platformdur. İnsan için iyi fikirler sunan bir platformuz. Eğitimler ve sıra dışı etkinlikler ile gelişiminize katkı sağlamak, hayata yeni bakış açılarıyla bakmanıza ve yeni sorulara kapı açmanıza yardımcı olmak istiyoruz.</p>
                  </div>
                  
                  <router-link to="/" class="e-btn e-btn-border">Eğitimlerimiz</router-link>
               </div>
            </div>
         </div>
      </div>
   </section>
</template>

<script>
export default {
   name:'AboutArea'
};
</script>
